/**
 * FILTER-CREATE
 * Create new filter from topic and question
 */

import { WithTranslation, withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { TopicState } from "@/redux/topic.types"
import { Session } from "@/redux/_session.types"
import ModalConfirm from "@/components/modal-confirm"
import { SurveyState } from "@/redux/survey.types"
import { Question } from "@/redux/question.types"
import { store } from "@/core/root-reducer"
import { filterCreateFromQuestion } from "@/redux/filter.actions"
import { STATUS_SAVED, STATUS_SAVING } from "@/redux/_status.types"
import { topicStatus } from "@/redux/topic.actions"
import TextInput from "@/components/text-input"
import { useState } from "react"

interface StateProps {
  _session: Session
  survey: SurveyState
  topic: TopicState
}

interface OwnProps {
  onClose: Function
  currentQuestion: Question
}

type Props = StateProps & OwnProps & WithTranslation

function FilterCreateFromQuestionModal(props: Props) {
  const { t } = props

  //Name of the filter to create (topic label by default)
  const [filterName, setFilterName] = useState<string>(props.topic.active.label)

  async function confirm() {
    if (!filterName.trim()) {
      alert("Veuillez saisir un nom pour le filtre")
      return
    }

    if (props.currentQuestion.aid && props.topic.active.aid) {
      store.dispatch(topicStatus(STATUS_SAVING))
      await store.dispatch(
        filterCreateFromQuestion(
          props.survey.active.id,
          props.currentQuestion.aid,
          props.topic.active.aid,
          filterName.trim()
        )
      )
      store.dispatch(topicStatus(STATUS_SAVED))
      alert("Veuillez quitter le tableau de bord pour recharger les filtres")
      props.onClose()
    } else {
      alert("pas d'identifiant pour la question ou le topic")
    }
  }

  return (
    <ModalConfirm
      status={props.topic.status}
      onNo={() => props.onClose()}
      onYes={() => confirm()}
      textBold={t("utils_next_ask")}>
      <div className="height-20" />

      <TextInput
        autoFocus
        isFullWidth
        required
        title={t("filter_name")}
        value={filterName}
        onChange={(e) => setFilterName(e.value)}
        onKeyDown={(key) => key === "Enter" && confirm()}
      />
    </ModalConfirm>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  survey: state.survey,
  topic: state.topic
})

export default connect(mapStateToProps)(withTranslation()(FilterCreateFromQuestionModal))
